import { useEffect } from 'react';

import { PartnerLookupWidget } from 'components/partner_lookup';
import { DefaultLayout } from 'components/layout/DefaultLayout';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Partner, PartnerApi } from 'apis/PartnerApi';
import { Container } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

export const PartnerLookup = () => {

    const [state, setState] = useSuperState({
        ready: false,
        selecting: false
    });
    const { ready, selecting } = state;

    const { formatMessage } = useIntl();
    const { refreshAppBasics } = useApp();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const partnerType = Number(searchParams.get('PType')) || undefined;
    const refPage = searchParams.get('RefPage') ?? '';

    // Reset selected partner on mount so the lookup API returns the full list.
    useEffect(() => {

        (async () => {

            try {

                await PartnerApi.ClearSelectedPartner();
                await refreshAppBasics();

            } finally {

                setState({ ready: true });

            }

        })();

    }, []);

    const handleSelect = async (partner: Partner) => {

        setState({ selecting: true });

        try {

            await PartnerApi.SetSelectedPartner(partner.ID ?? partner.Id);
            await refreshAppBasics();

            if (refPage) {

                const separator = refPage.includes('?') ? '&' : '?';
                navigate(`${refPage}${separator}PId=${partner.ID ?? partner.Id}`);

            } else {

                navigate('/');

            }

        } catch {

            setState({ selecting: false });

        }

    };

    const titleMap: Record<number, string> = {
        2: formatMessage({ id: 'distributor_lookup.d955648e', defaultMessage: 'Distributor Lookup' }),
        3: formatMessage({ id: 'reseller_lookup.e40f6599', defaultMessage: 'Reseller Lookup' }),
        4: formatMessage({ id: 'testing_center_lookup.5a953f91', defaultMessage: 'Testing Center Lookup' })
    };

    const pageTitle = partnerType
        ? titleMap[partnerType] ?? (formatMessage({ id: 'partner_lookup.7135d3ea', defaultMessage: 'Partner Lookup' }))
        : (formatMessage({ id: 'partner_lookup.7135d3ea', defaultMessage: 'Partner Lookup' }));

    return (
        <DefaultLayout pageTitle={pageTitle}>
            <Container fluid className={selecting ? 'opacity-50 pe-none' : ''}>
                {ready && (
                    <PartnerLookupWidget
                        singleSearch
                        onSelect={handleSelect}
                        partnerType={partnerType}
                        title={pageTitle}
                    />
                )}
            </Container>
        </DefaultLayout>
    );

};
